import { css } from '@emotion/css';
import { Theme, Typography } from '@mui/material';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useStyles } from '@/hooks/useStyles.ts';
import { MedicationSchema } from '@/models/ConditionModel.ts';
import { InformationPaper } from '@/uiKit/atoms/InformationPaper.tsx';

export const SupportedInsulinPumpInfoBox = () => {
  const { t } = useTranslation();
  const styles = useStyles(makeStyles);
  const insulinScheme = useWatch({
    name: 'insulinScheme',
  }) as MedicationSchema | undefined;

  if (insulinScheme === 'insulinPump') {
    return (
      <InformationPaper className={styles.container}>
        <Typography sx={{ fontWeight: 'bold' }}>
          {t('diabetesForms.supportedPumpsTitle')}
          {' : '}
        </Typography>
        <Typography component="span">
          {t('diabetesForms.supportedPumpsList')}
        </Typography>
        <Typography>{t('diabetesForms.supportedPumpsInfo')}</Typography>
      </InformationPaper>
    );
  }

  return null;
};

const makeStyles = (theme: Theme) => ({
  container: css`
    display: flex;
    flex-direction: column;
    margin: ${theme.spacing(0, 0, 12, 0)};
  `,
});
